import endpoints from "../models/api/api.endpoints";
import api from "../helpers/api.service";
import Helper from "../helpers/helper.service";
import ServiceResponseCode from "../models/service.response.code";
import userService from '../helpers/user.service'

let refreshInProgress = null

export default {
  async login(data) {
    try {
      const url = `${endpoints.authLogin}`;
      const result = await api.login(url, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Message: e.Message,
        Success: false,
      }
    }
  },
  async loginExterno(data) {
    try {
      const url = `${endpoints.authLoginExterno}`;
      const result = await api.login(url, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Message: e.Message,
        Success: false,
      }
    }
  },
  async loginSso(data) {
    try {
      const url = `${endpoints.authLoginSso}`;
      const result = await api.login(url, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Message: e.Message || e.message,
        Success: false,
      }
    }
  },
  async getSsoConfig() {
    try {
      const result = await api.get(endpoints.authSsoConfig, true)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Message: e.Message || e.message,
        Success: false,
      }
    }
  },
  async validate(data) {
    try {
      const url = `${endpoints.authValidate}`;
      const result = await api.login(url, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Message: e.Message,
        Success: false,
      }
    }
  },
  /**
   * Renova o JWT se já se passaram intervalHours desde o último refresh/login local.
   * Default: 12 horas.
   */
  async refreshTokenIfNeeded(intervalHours = 12) {
    const user = userService.getLocalUser(false)
    if (!user)
      return false

    const lastRefreshMs = user.requested ?? (user.created_at ? user.created_at * 1000 : null)
    if (lastRefreshMs == null)
      return false

    const hoursElapsed = (Date.now() - lastRefreshMs) / (1000 * 60 * 60)
    if (hoursElapsed < intervalHours)
      return false

    return await this.refreshToken()
  },
  async refreshToken() {
    if (refreshInProgress)
      return refreshInProgress

    refreshInProgress = (async () => {
      try {
        const url = endpoints.authRefreshToken
        const result = await api.get(url)
        const response = Helper.getServiceResponse(result)

        if (response.Success) {
          userService.saveUser(response.Data)
          return true
        }

        console.error('não foi possível realizar o refresh token')
        return false
      } catch (e) {
        console.error('erro no refresh token', e)
        return false
      } finally {
        refreshInProgress = null
      }
    })()

    return refreshInProgress
  },
  async Logout() {
    try {
      const url = endpoints.authLogout
      const result = await api.post(url);
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Message: e.message,
        Success: false,
      }
    } finally {
      userService.destroyUser()
    }
  },
  async forgotPassword(email, modalidade, url) {
    try {
      const data = {
        Email: email,
        Modalidade: modalidade,
        Url: url
      }
      const result = await api.post(endpoints.authForgotPassword, data, true)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Message: e.message,
        Success: false,
      }
    }
  },
  async requestChangePassword(data = undefined) {
    try {
      const result = await api.post(endpoints.authRequestChangePassword, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Message: e.message,
        Success: false,
      }
    }
  },
  async changePassword(Id, Password, PasswordConfirmacao, TokenAlterarSenha = null) {

    try {
      const data = {
        Id: Id,
        Password: Password,
        PasswordConfirmacao: PasswordConfirmacao,
        TokenAlterarSenha
      }
      const result = await api.post(endpoints.authChangePassword, data, (TokenAlterarSenha) ? true : false)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Message: e.message,
        Success: false,
      }
    }

  },
  async logUsuario(url, method, body, headers) {
    try {
      const data = {
        dados: {
          url: url,
          method: method,
          body: body,
          headers: headers
        }
      }
      const result = await api.post(endpoints.logUsuario, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Message: e.message,
        Success: false,
      }
    }
  },

}
